<script lang="ts">
import { preloadImage, getImageUrlFromSrc, resizeImageUrl, getDensityMultiplier } from '@/utils'
import { onMounted, ref } from 'vue'
export default {
  name: 'renderless-image-preloader',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { slots }) {
    const observerElement = ref()
    const multiplier = getDensityMultiplier()
    const observer = new IntersectionObserver(([ entry ]) => {
      if (entry.isIntersecting) {
        observer.unobserve(observerElement.value)
        props.images.map(i => {
          const url = getImageUrlFromSrc(String(i))
          const width = Number(url.searchParams.get('width'))
          const src = resizeImageUrl(url, width * multiplier)
          preloadImage(src)
        })
      }
    })
    onMounted(() => observer.observe(observerElement.value))
    // @ts-ignore
    return () => slots.default({ observerElement })
  }
}
</script>
